export default __webpack_public_path__ + "static/media/ax.dae59e50.svg";